var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { uuid } from "./uuid";
export const uploadFileToS3 = (fileName, fileType, file) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationId = process.env.REACT_APP_APPLICATION_ID;
    const uploadName = applicationId + "/" + uuid() + "/" + fileName.split(" ").join("-");
    const authToken = localStorage.getItem("token");
    const configGetS3Url = {
        url: `${process.env.REACT_APP_HELLOAR_API}signed_file`,
        params: {
            file_name: uploadName,
            file_type: fileType,
            application_id: applicationId,
        },
        headers: { Authorization: authToken },
    };
    try {
        const response = yield axios.request(configGetS3Url);
        let formData = new FormData();
        let key;
        for (key in response.data.data.fields) {
            formData.append(key, response.data.data.fields[key]);
        }
        formData.append("file", file);
        yield axios.post(response.data.data.url, formData);
        return response.data.uploaded_url;
    }
    catch (err) {
        throw new Error("Error while uploading content" + JSON.stringify(err));
    }
});
